<template>
  <div class="article-data-list-small">
    <div class="data-list" v-if="!loading">
      <div class="list-item" v-for="item in dataList" @click="jump('/detail/'+item.articleId)">
        <div class="item-img">
          <img class="lazy-image" v-lazy="item.cover">
        </div>
        <div class="item-info">
          <div class="info-title" v-html="item.title"></div>
          <div class="info-other">
            <span class="other-time">{{ item.fromToday }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="loading" v-if="loading">
      加载中...
    </div>
  </div>
</template>

<script>

export default {
  props: {
    dataList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      today: "",
      className: "",
    }
  },
  mounted() {
    switch (this.type) {
      case "mini":
        this.className = "list_body_mini"
        break
      default:
        this.className = "list_body";
        break
    }
  },
  methods: {
    jump(url) {
      window.open(url)
    },
  }
}
</script>

<style lang="scss">
.article-data-list-small {
  .data-list {
    background-color: --color(--p-white);
    border-radius: $base-border-radius;

    .list-item:hover {

      img {
        transform: scale(1.2);
      }

      .item-info {
        .info-title {
          color: $base-color-primary;
        }
      }
    }

    .list-item {
      transition: 0.2s;
      cursor: pointer;
      display: flex;
      border-bottom: 1px solid --color(--p-border-f5);
      padding: 10px 0;

      .item-img {
        width: 100px;
        height: 50px;
        border-radius: $base-border-radius;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: 0.2s;
        }
      }

      .item-info {
        flex: 1;
        margin-left: 10px;
        position: relative;
        word-wrap: break-word;
        word-break: break-all;

        em {
          color: red;
          font-style: normal;
        }

        .info-title {
          font-size: 14px;
          font-weight: 500;
          color: --color(--p-text-34);
          transition: 0.2s;
          margin-bottom: 10px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .info-introduce {
          margin-bottom: 10px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 14px;
          color: --color(--p-text-88);
        }

        .info-other {
          font-size: 12px;
          color: --color(--p-text-88);
          position: absolute;
          bottom: 0;
          left: 0;

          span {
            margin-right: 20px;
          }

          .time-status {
            color: red;
          }
        }
      }
    }
  }

  .loading {
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: --color(--p-text-34);
  }
}
</style>
